<template>
  <div class="cascaderSearch" @mouseenter="isMouseIn=true" @mouseleave="isMouseIn=false" :style="cssVar">
    <el-popover
        ref="popover"
        placement="bottom-start"
        :visible-arrow="false"
        popper-class="cascader_popover"
        trigger="click"
        @show="isShowList=true;relocation()"
        @hide="isShowList=false"
        @after-enter="afterShow">
      <div class="default_area" v-show="isShowList">
        <div class="haveData" v-show="taskList.length>0">
          <div class="search" v-if="isCanSearch==='true'">
            <el-input
                size="mini"
                placeholder="请输入内容"
                prefix-icon="kdfont kdfont-f"
                v-model="searchText"
                @change="searchTask"
            >
            </el-input>
          </div>
          <div class="check_box">
            <el-cascader-panel :key="refresh" ref="cascader" :options="taskListShow" v-model="checkList"
                               v-if="taskListShow.length > 0 && isShowPanel"
                               :props="{emitPath:true,multiple:multiple==='true'}"
                               @change="changePanel"
                               @expand-change="relocation"
            ></el-cascader-panel>
            <div class="noData" v-show="taskListShow.length === 0">搜索结果为空</div>
          </div>
          <div class="selected" v-if="multiple ==='true'">已选 <span>{{ checkList.length }}</span> 项</div>
        </div>
        <div class="noData" v-show="taskList.length === 0">暂无可选数据</div>
      </div>
      <div slot="reference" class="input_area">
        <div class="text_area_multiple" v-if="multiple ==='true'">
          <div class="text_item" v-for="(item,index) in checkList">
            <span class="text">{{ item[item.length - 1] }}</span>
            <span class="kdfont kdfont-guanbi8" @click.stop="deleteItem(item)"></span>
          </div>
        </div>
        <div class="text_area_single" v-if="multiple ==='false'">
          <div class="text_item">
            <span class="text">{{ checkList[checkList.length - 1] }}</span>
          </div>
          <div class="kdfont kdfont-guanbi8" @click.stop="clearSelected"></div>
        </div>
        <div class="kdfont kdfont-xiala" :class="{'rotate':isShowList}"></div>
      </div>
    </el-popover>
  </div>
</template>

<script>
import {utils} from "../../intvTaskCale/common/common";

export default {
  components: {},
  props: {
    invoke: Function,
    taskListSource: Array,
    getSelected: String,
    multiple: String,
    levelNum: String,
    isCanSearch: String,
    initSelected: Array,
    themeNum:String
  },
  computed: {
    cssVar() {
      return {
        '--color': this.themeNum,
      }
    }
  },
  watch: {
    taskListSource: function (list) {
      this.taskList = this.taskListShow = this.formatSourceData(list);
    },
    initSelected: function (list) {
      this.checkList = list;
      this.refresh++;//刷新级联数据
    },
    updateTaskList: function (list) {
      this.taskList = this.taskListShow = this.formatSourceData(list);
    },
    getSelected: function (value) {
      if (value.includes('true')) {
        this.invoke("selectedData", this.formatCheckList());
      }
      this.checkList = [];
    },
  },
  filters: {
    formatDate(val) {

    },
  },
  data() {
    return {
      cascaderList: ['first_class', 'second_class', 'third_class', 'fourth_class'],//级联等级key值
      checkList: [],//已选值（单选为一维数组，多选为二维数组）
      taskList: [],//经格式化后的源数据
      taskListShow: [],//格式化后需要展示的源数据
      searchText: "",//搜索关键词
      isShowList: false,
      isShowPanel: true,
      isMouseIn: false,
      refresh: 1,
    }
  },
  mounted() {

  },
  methods: {
    /**
     *单个删除已选项 （针对多选）
     * @param value 已选项值
     */
    deleteItem(value) {
      if (this.multiple === 'true') {
        let num = this.checkList.indexOf(value);
        this.checkList.splice(num, 1)
      } else {
        this.checkList = [];
      }
      this.refresh++;
    },

    /**
     * 全部清除已选项（针对单选）
     */
    clearSelected() {
      this.checkList = [];
      this.relocation();
      this.invoke("selectedData", "");
    },

    /**
     * 筛选得出搜索结果
     */
    searchTask() {
      if (this.searchText === '') {
        this.taskListShow = this.taskList;
        return;
      }
      let newList = [];
      for (let x in this.taskListSource) {
        if (this.taskListSource[x][this.cascaderList[Number(this.levelNum) - 1]].includes(this.searchText)) {
          newList.push(this.taskListSource[x]);
        }
      }
      this.taskListShow = this.formatSourceData(newList);
      this.relocation();
    },

    /**
     * 已选值改变时触发
     */
    changePanel() {
      this.relocation();
      if (this.multiple === 'false') {
        this.invoke("selectedData", this.formatCheckList());
      }
    },

    /**
     * 重新定位级联弹框
     */
    relocation(){
      this.$nextTick(() => {
        this.$refs.popover.updatePopper();
        console.log(this.$refs.cascader.$refs.panel)
      })
    },

    /**
     * 组装数据
     * @param itemObj 数据对象
     * @param node 当前节点
     * @param index 当前层级数
     * @returns {*} 当前组装好的节点
     */
    analysisLevel(itemObj, node, index) {
      //存放第一层数据
      let levelList = [];
      let firstIndex = node[this.cascaderList[index]].indexOf(itemObj[this.cascaderList[index]])
      if (firstIndex > -1) {
        levelList = node.children[firstIndex]
      } else {
        node[this.cascaderList[index]].push(itemObj[this.cascaderList[index]]);
        node.children.push({
          value: itemObj[this.cascaderList[index]],
          label: itemObj[this.cascaderList[index]],
          [this.cascaderList[index + 1]]: [],
          [index + 1 < Number(this.levelNum) ? 'children' : 'void']: []
        })
        levelList = node.children[node.children.length - 1]
      }
      return levelList;
    },

    /**
     * 格式化源平铺数据为级联数据
     * @param list  源数据
     * @returns {[]|*} 格式化后的级联数据
     */
    formatSourceData(list) {
      let newTaskArray = {
        [this.cascaderList[0]]: [],
        children: [],
      };
      for (let item in list) {
        let levelNum = Number(this.levelNum);
        let levelList = newTaskArray;
        for (let i = 0; i < levelNum; i++) {
          levelList = this.analysisLevel(list[item], levelList, i);
        }
      }
      return newTaskArray.children
    },

    /**
     * 格式化需要返回给后台的数据
     * @returns {{}|null|[]} 格式化后的结果
     */
    formatCheckList() {
      if (this.multiple === 'true') {
        let resultList = [];
        for (let x in this.checkList) {
          let itemObj = {};
          let num = this.levelNum;
          for (let y = 0; y < num; y++) {
            itemObj[this.cascaderList[y]] = this.checkList[x][y];
          }
          resultList.push(itemObj);
        }
        return resultList;
      } else if (this.multiple === 'false') {
        let itemObj = {};
        let num = this.levelNum;
        for (let y = 0; y < num; y++) {
          itemObj[this.cascaderList[y]] = this.checkList[y];
        }
        return itemObj;
      }
      return null;
    },
    afterShow(){
      this.isShowList = true
      //赋与主题色
      let eleS = $(".cascader_popover");
      for (let i = 0, len = eleS.length; i < len; i++) {
        eleS[i].style.setProperty('--color',this.themeNum);
      }

    }
  }
}
</script>
<style lang="less">
.cascaderSearch {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  position: relative;

  .input_area {
    display: flex;
    align-items: center;
    height: 26px;
    flex-shrink: 0;
    border-bottom: 1px solid #999;

    &:hover{
      border-color: #5582F3;
      border-color: var(--theme-color);
    }
    &:hover>.kdfont{
      color: #5582F3;
      color: var(--theme-color);
    }
    .text_area_multiple{
      flex-shrink: 1;
      flex-grow: 1;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: start;
      .text_item {
        flex-shrink: 0;
        flex-grow: 0;
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #212121;
        margin-right: 5px;

        .kdfont {
          color: #5582F3;
          color: var(--theme-color);
          font-size: 14px;
          display: none;
        }

        &:hover > .kdfont {
          display: inline;
        }
      }
    }
    .text_area_single{
      flex-shrink: 1;
      flex-grow: 1;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .text_item {
        flex-shrink: 1;
        flex-grow: 1;
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #212121;
        width: 10px;
        .text{
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
      .kdfont-guanbi8 {
        flex-shrink: 0;
        flex-grow: 0;
        display: none;
        font-size: 14px;
        color: #5582F3;
        color: var(--theme-color);
      }

      &:hover > .kdfont-guanbi8 {
        display: block;
      }
    }

    .kdfont-xiala {
      transition: transform .2s ease, -webkit-transform .2s ease;
      padding: 1px;
      margin-left: 10px;
    }

    .rotate {
      transform: rotate(180deg);
    }
  }
}
.cascader_popover{
  padding: 0 !important;
  margin-top: 6px !important;
  border: 0 !important;
  border-radius: 0 !important;
  -webkit-box-shadow: 0 1px 8px 0 rgba(0, 0, 0, .2) !important;
  box-shadow: 0 1px 8px 0 rgba(0, 0, 0, .2) !important;
  background-color: #fff;
  min-width: 160px;
  -webkit-animation: q-hasJSd 1s steps(1) 0s 1 normal none !important;
  animation: q-hasJSd 1s steps(1) 0s 1 normal none !important;
  -webkit-transform-origin: 50% 0 !important;
  -ms-transform-origin: 50% 0 !important;
  transform-origin: 50% 0 !important;
  .default_area {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    border-radius: 2px;
    .search {
      padding: 10px 10px 10px 10px;

      .el-input {
        display: flex;

        input {
          flex-grow: 1;
          width: 100px;
          &:hover{
            border-color: #5582F3;
            border-color: var(--theme-color);
          }
          &:hover+.el-input__prefix>.el-input__icon{
            color: var(--theme-color);
          }
          &:focus{
            border-color: #5582F3;
            border-color: var(--theme-color);
          }
          &:focus+.el-input__prefix>.el-input__icon{
            color: #5582F3;
            color: var(--theme-color);
          }
        }
      }
    }

    .check_box {
      .el-cascader-panel {
        border: 0;
        border-radius: 0;
        border-bottom: 1px solid #ccc;
        border-top: 1px solid #E4E7ED;

        .el-cascader-menu {
          .el-cascader-node {
            height: 32px;
            font-size: 12px;

            .el-icon-check {
              font-family: kdfont !important;

              &::before {
                content: "\eb2d";
              }
            }

            .el-checkbox__inner {
              border: 0 !important;
              font-size: 13px;
              color: #d9d9d9;
              background: none !important;
              font-family: kdfont !important;

              &::after {
                border: 0;
                transform: none;
                position: initial;
                content: "\e9f1";
              }
            }

            &:hover {
              background: #f5f5f5;
            }

            .el-checkbox {
              .is-checked {
                .el-checkbox__inner {
                  color: #5582F3;
                  color: var(--theme-color);

                  &::after {
                    transform: none;
                    position: initial;
                    content: "\e9f2";
                  }
                }
              }

              .is-indeterminate {
                .el-checkbox__inner {
                  color: #5582F3;
                  color: var(--theme-color);

                  &::before {
                    transform: none;
                    position: initial;
                    content: "\eaf9";
                  }
                }
              }
            }
          }

          .in-active-path {
            color: #5582F3;
            color: var(--theme-color);
          }

          .is-active {
            color: #5582F3;
            color: var(--theme-color);
          }

          .el-icon-arrow-right {
            font-family: kdfont !important;

            &::before {
              content: "\eabb";
            }
          }
        }
      }
    }

    .selected {
      height: 32px;
      line-height: 32px;
      padding: 0 14px 0 12px;
      color: #999999;

      span {
        color: #5582F3;
        color: var(--theme-color);
      }
    }
    .haveData {
      display: flex;
      flex-direction: column;
      align-items: stretch;
    }

    .noData {
      padding: 30px 0;
      text-align: center;
      color: #999;
    }
  }
}
</style>